<template>
  <div class="content-block">
    <UsersTable></UsersTable>
  </div>
</template>

<script>
import UsersTable from 'CORE/components/users/table'

export default {
    name: 'UsersAdministrationTable',
    components: {
        UsersTable,
    },
}
</script>
